<script>
export default {
  props: ["debug", "name"],
  mounted() {
    console.warn(this.name ?? "f-debug", this.debug);
  },
  watch: {
    debug(d) {
      console.warn(this.name ?? "f-debug", 'CHANGED', d);
    }
  }
};
</script>
<template>
  <div>
    <slot></slot>
  </div>
</template>